import { on } from 'delegated-events'
import { handleValidation } from '@common/validation'
import ky from '@common/ky'
import scrollTo from '@common/scroll-to'
import { handleAjaxSubmit } from '../scripts/components/styled-form.js'
import { animate, inView, stagger } from "motion";

const wrapper = document.querySelector('.donate-form-wrapper')
const form = document.querySelector('.donate-form')
const submitButton = form.querySelector('[type=submit]')
const amountView = form.querySelector('.amount-view')
const paymentView = form.querySelector('.payment-view')
const amountField = form.querySelector('input[name=Amount]')
const summaryField = form.querySelector('.payment-summary')

const recurringLabels = {
  biweekly: '2 weeks',
  monthly: 'month',
  quarterly: '3 months',
  annually: 'year',
  biannually: '6 months',
}

const state = {
  view: 'amount',
  frequency: form.querySelector('input[name="Frequency"]:checked').value,
  recurringFrequency: form.querySelector('select[name="RecurringFrequency"]').value,
}

let stripe;
let elements;

const initializePaymentForm = async (form, type) => {
  stripe = window.Stripe(form.dataset.stripeKey);

  const appearance = {
    labels: "floating",
    theme: "stripe",
    variables: {
      colorPrimary: "#158F58",
      colorBackground: "#ffffff",
      colorDanger: "#DE1D1D",
      borderRadius: "50px",
      gridColumnSpacing: "24px",
      gridRowSpacing: "16px",
    },
    rules: {
      '.Input': {
        fontFamily: "Gotham, sans-serif",
        fontWeight: 500,
        colorTextPlaceholder: "#484848",
        paddingTop: "10px",
        paddingLeft: "25px",
        border: "unset",
        boxShadow: "unset",
      },
      '.Tab': {
        paddingLeft: "25px",
      },
      '.Block': {
        paddingLeft: "25px",
        paddingTop: "25px",
        paddingBottom: "25px",
      },
      '.TabLabel': {
        fontFamily: "Gotham, sans-serif",
        fontWeight: 600,
        colorTextPlaceholder: "#484848",
      },
    },
  };

  try {
    const endpoint = form.dataset.paymentEndpoint;

    const data = new FormData(form);
    data.set("type", type);
    data.set("amount", parseFloat(amountField.value.replaceAll(',', '')));

    const res = await ky.post(endpoint, { body: data }).json();

    elements = stripe.elements({ clientSecret: res.clientSecret, appearance });

    const paymentElement = elements.create("payment", {
      layout: "tabs",
    });
    paymentElement.mount("#payment-element");
  } catch (error) {
    console.error(error);
  }
};

const handlePaymentSubmit = async (e) => {
  e.preventDefault();

  const form = e.currentTarget;
  const isValid = handleValidation(form);

  if (!isValid) {
    return;
  }

  const formData = new FormData(form);

  const billingDetails = {};

  billingDetails.name = `${formData.get("FirstName")} ${formData.get("LastName")}`;
  billingDetails.email = formData.get("Email");
  billingDetails.phone = formData.get("Phone");
  billingDetails.address = {
    line1: formData.get("BillingAddress"),
    line2: formData.get("BillingAddress2"),
    city: formData.get("BillingCity"),
    state: formData.get("BillingState"),
  };

  submitButton.disabled = true;
  submitButton.classList.add("is-loading");

  const { error, paymentIntent } = await stripe.confirmPayment({
    elements,
    confirmParams: {
      return_url: "https://healthyshelf.org",
      payment_method_data: {
        billing_details: billingDetails,
      },
    },
    redirect: "if_required",
  });

  if (error && (error.type === "card_error" || error.type === "validation_error")) {
    showMessage(error.message);
    submitButton.disabled = false;
    submitButton.classList.remove("is-loading");
  } else if (paymentIntent && paymentIntent.status === "succeeded") {
    // Get the payment intent id and set it to the hidden field
    const paymentIntentId = paymentIntent.id;
    let paymentIntentHiddenField = document.querySelector("#DonationForm_DonationForm_StripePaymentIntentId");
    paymentIntentHiddenField.value = paymentIntentId;

    handleAjaxSubmit(e);
  } else {
    showMessage("An unexpected error occurred.");
    submitButton.disabled = false;
    submitButton.classList.remove("is-loading");
  }
};

function showMessage(messageText) {
  const messageContainer = document.querySelector("#payment-message");

  messageContainer.classList.remove("hidden");
  messageContainer.textContent = messageText;

  setTimeout(function () {
    messageContainer.classList.add("hidden");
    messageContainer.textContent = "";
  }, 4000);
}

const render = () => {
  if (state.view === 'amount') {
    amountView.classList.add('is-active')
    paymentView.classList.remove('is-active')
  }

  if (state.view === 'payment') {
    amountView.classList.remove('is-active')
    paymentView.classList.add('is-active')

    const els = paymentView.querySelectorAll(`[data-reveal="fade-up"]`);

    let duration = 1;

    if (els.length) {
      inView(
        paymentView,
        () => {
          animate(els, { opacity: [0, 1], y : [100, 0] }, {duration, delay: stagger(0.2),
          }).finished.then((animations) => {
            animations?.forEach((animation) => {
              animation.effect?.target?.setAttribute("data-sr-done", true);
            });
          });
        },
        {
          margin: "0px 0px -25% 0px",
        },
      );
    }


    let summary = `$ ${amountField.value}.00`

    if (state.frequency === 'Recurring') {
      summary = `${summary} every ${recurringLabels[state.recurringFrequency]}`
    }

    summaryField.value = summary
  }

  scrollTo(wrapper)
}

const init = () => {

  on('input', 'input[name=Amount]', (e) => {
    amountField.setAttribute('value', e.target.value)
  })

  on('click', '.donation-amount', (e) => {
    const amount = e.target.dataset.value

    // Remove active class from all other amounts
    document.querySelectorAll('.donation-amount').forEach((x) => x.classList.remove('is-active'))

    // Add active class to the selected amount
    e.target.classList.add('is-active')

    const updateEvent = new CustomEvent('updateValue', { detail: amount })

    amountField.dispatchEvent(updateEvent)

    amountField.setAttribute('value', amount)
  })

  on('click', 'input[name="Frequency"]', (e) => {
    if (e.target.checked) {
      state.frequency = e.target.value
    }
  })

  on('change', 'select[name="RecurringFrequency"]', (e) => {
    state.recurringFrequency = e.target.value
  })

  on('click', '.amount-view-trigger', () => {
    state.view = 'amount'
    render()
  })

  on('click', '.payment-view-trigger', () => {

    const isValid = handleValidation(form);

    if (!isValid) {
      return;
    }

    state.view = 'payment'
    render()

    if (!form) {
      return;
    }

    //get frequency type
    const type = form.querySelector('input[name="Frequency"]:checked').value;

    initializePaymentForm(form, type);

    form.addEventListener("submit", handlePaymentSubmit);
  })

  on('click', '.donation-form-link', (e) => {

    e.preventDefault()
    const buttonAmount = e.target.dataset.donationAmount
    let cleanPrice = buttonAmount.replace(/[$,]/g, '');
    let priceAsInteger = parseInt(cleanPrice, 10);

    let buttons = document.querySelectorAll('.donation-amount-btn');
    buttons.forEach(function(button) {
      button.classList.remove('is-active');
    });

    let button = document.querySelector(`button[data-value="${priceAsInteger}"]`);
    if (button) {
      button.classList.add("is-active");
    }

    amountField.value = buttonAmount.replace(/[$]/g, '');;
    amountField.setAttribute('value', cleanPrice)

  })

}

init()
